// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./bg_enter_no.png");
var dir = previousRequest.replace("bg_enter_no.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "bg_enter_no.png",
	name: "bg_enter_no",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/bg_enter_no.png
// module id = 996
// module chunks = 4